import { formatDateRange, formatDayLabel, formatRelativeDay } from "../utils/format.js";
import { logSpan, trainingSummary } from "../utils/milestones.js";
import Avatar from "./Avatar.jsx";
import styles from "./ProfileHeading.module.css";

export default function ProfileHeading({ profile, username, analytics, lastWorkout, workouts, pagination }) {
  const displayName = profile?.fullName || username;
  const dateRange = formatDateRange(analytics?.periods?.current);

  // The preview carries the last workout, so this line is up as soon as the
  // profile resolves — it does not wait on the history import below it.
  const lastWorkoutAt = formatRelativeDay(lastWorkout?.startTime);

  const span = logSpan(workouts);
  // The oldest imported workout is the floor of what we fetched, not the day
  // they started, so only an import that reached the whole history may say
  // "since". The count itself stays in historyWarning rather than being
  // repeated here.
  const truncated = Boolean(pagination?.budgetReached && pagination?.hasMore);
  const since = span && (truncated
    ? `Imported history starts ${formatDayLabel(span.firstDate)} — older workouts were not fetched`
    : `Logging since ${formatDayLabel(span.firstDate)}`);
  const summary = trainingSummary(span);

  return (
    <div className={styles.root}>
      <div className={styles.identity}>
        <Avatar imageUrl={profile?.imageUrl} name={displayName} seed={username} size={44} />
        <div className={styles.identityText}>
          <h1 id="dashboard-profile-name" className={styles.name}>{displayName}</h1>
          <p id="dashboard-profile-meta" className={styles.meta}>
            <span>@{username}</span>
            {lastWorkoutAt && (
              <>
                <span className={styles.sep} aria-hidden="true">·</span>
                <span>Last workout {lastWorkoutAt}</span>
              </>
            )}
          </p>
        </div>
      </div>

      {dateRange && (
        <div className={styles.range}>{dateRange}</div>
      )}

      {since && (
        <p id="dashboard-profile-history" className={styles.history}>
          <span>{since}</span>
          {summary && (
            <>
              <span className={styles.sep} aria-hidden="true">·</span>
              <span className={styles.milestone}>{summary}</span>
            </>
          )}
        </p>
      )}
    </div>
  );
}
